/* -------------------------------------------------------------------------- *
 * Clicks the Hamburger Button *
 * -------------------------------------------------------------------------- *
 */

const settings = {
    selector: '.js-clickClose',
};

const closeButtons = document.querySelectorAll('.js-clickClose');
const headerButton = document.getElementById('js-headerBtn');

/* ------------- *
 * Module Export *
 * ------------- */

const ClickHamburgerButton = {
    selector: settings.selector,

    init() {
        if (headerButton) {
            closeButtons.forEach((closeButton) => {
                closeButton.addEventListener('click', (event) => {
                    event.preventDefault(); // Prevent the default link behavior if needed
                    headerButton.click(); // Trigger a click event on the header button
                });
            });
        }
    },
};

export default ClickHamburgerButton;
